import { LINE_ITEM_CUSTOMER_COMMISSION, LINE_ITEM_PROVIDER_COMMISSION } from "./types";

export const getUnitType = (itemPackage) => {
    const unitType = itemPackage === 'perMinutePrice'
        ? 'minute' : itemPackage === 'perHourPrice'
            ? 'hour' : itemPackage === 'perDayPrice'
                ? 'day' : itemPackage === 'overnightPrice'
                    ? 'night' : itemPackage === 'twoDaysPrice'
                        ? 'twoDays' : itemPackage === 'oneWeekPrice'
                            ? 'perWeek' : itemPackage === 'twentyEightDaysPrice'
                                ? 'twentyEightDays' : null;
    return unitType;
};

export function getMainItem(lineItems) {
    return lineItems.find(lineItem => lineItem.item === true);
}